import React from "react";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import { FullWidthBase } from "../base/fullWidthBase";

interface Props {
  onClick: () => void;
  text: string;
}

export const FormPlaceholder = ({ onClick, text }: Props) => (
  <FullWidthBase>
    <AgentButton buttonStyle={"transparent primary"} onClick={onClick}>
      {text}
    </AgentButton>
  </FullWidthBase>
);
